import React from 'react';
import { motion } from 'framer-motion';
import Container from '../common/container';

export default function WhatWeDo() {
  const stats = [
    { value: '5x', label: 'Faster Response' },
    { value: '24/7', label: 'Service Availability' },
    { value: '60%', label: 'Cost Reduction' }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">What We Do</h2>
          <p className="text-lg text-gray-600">
            WymBee transforms popular messaging apps into powerful business engines—automating sales, customer support, and engagement so companies can respond 5x faster, provide 24/7 service, and reduce operational costs by more than 60%.
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="bg-white rounded-xl shadow-sm p-8 text-center hover:shadow-md transition-shadow duration-300"
            >
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2">{stat.value}</div>
              <div className="text-gray-600">{stat.label}</div>
            </motion.div>
          ))}
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="bg-white rounded-2xl shadow-sm p-8 md:p-10"
        >
          <p className="text-lg text-gray-600 leading-relaxed">
            Our no-code platform seamlessly integrates with WhatsApp and Telegram, enabling businesses across multiple sectors to automate conversations, build customer relationships, and drive sales directly within messaging apps.
          </p>
        </motion.div>
      </Container>
    </section>
  );
}